import { connect } from 'react-redux';
import PropertyTypes from './PropertyTypes';
import { fetchPropertyTypeImages } from '../../redux/modules/propertyTypeImages';

const mapStateToProps = ({
  content: {
    propertyTypes,
    siteStaticContent: {
      localizedCountryName
    }
  },
  system: {
    siteName
  },
  user: {
    cookie
  },
  propertyTypeImages: { imageUrls }
}) => ({
  propertyTypes,
  siteName,
  destination: localizedCountryName,
  propertyTypeImages: imageUrls,
  cookie
});

const mapDispatchToProps = {
  fetchPropertyTypeImages
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyTypes);
